// extracted by mini-css-extract-plugin
module.exports = {"navbar":"profile-nav_navbar__23YXI","button":"profile-nav_button__2DTrJ"};